import * as API from '@/endpoints'
import Axios from 'axios'
import Vue from 'vue'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    artworks: {},
    artwork: null,
    userArtworks: {},
    officialArtworks: {}
  },
  mutations: {
    setActiveCareplan (state, v) {
      Vue.set(state, 'artworks', v)
    },
    pushArtwork (state, v) {
      if (!_.isEmpty(state.artworks.careplan_item)) { state.artworks.careplan_item.push(v) }
    },
    setSingleArtwork (state, v) {
      Vue.set(state, 'artwork', v)
    },
    setUserArtwork (state, v) {
      Vue.set(state, 'userArtworks', v)
    },
    setOfficalArtwork (state, v) {
      Vue.set(state, 'officialArtworks', v)
    }
  },
  actions: {
    getCareplanInfo ({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.careplan + '/' + payload + '/item?asc=0&sort_by=rrule_parsed_date').then(
          res => {
            commit('setActiveCareplan', res.data)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getUserArtwork ({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.careplan + '/' + payload + '/item?asc=0&sort_by=rrule_parsed_date&filter=is_user:1').then(
          res => {
            commit('setUserArtwork', res.data)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getOfficialArtwork ({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.careplan + '/' + payload + '/item?asc=0&sort_by=rrule_parsed_date&filter=is_user:0').then(
          res => {
            commit('setOfficalArtwork', res.data)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    }
  }
}
